/*  A Vuex module. 
*   Store for global options for the applications which comes dynamically from database
*/
const state = {
    roles : [],
    locations : [],
    editors: [],
    isFormModified: false,
    deployedVersion: null
};

const mutations = {
    roles: (state, val) => {
        state.roles = val;
    },
    locations: (state, val) => {
        state.locations = val;
    },
    editors: (state, val) => {
        state.editors = val;
    },
    updateForm(state) {
        state.isFormModified = true;
    },
    resetForm(state) {
        state.isFormModified = false;
    },
    deployedVersion: (state, val) => {
        state.deployedVersion = val;
    },
};

const actions = {
    roles: ({ commit }, val) => {
        commit("roles", val);
    },
    locations: ({ commit }, val) => {
        commit("locations", val);
    },
    editors: ({ commit }, val) => {
        commit("editors", val);
    },
    updateForm({ commit }) {
        commit('updateForm')
    },
    resetForm({ commit }) {
        commit('resetForm')
    },
    deployedVersion: ({ commit }, val) => {
        commit("deployedVersion", val);
    },
};

const getters = {
    roles: (state) => {
        return state.roles;
    },
    locations: (state) => {
        return state.locations;
    },
    editors: (state) => {
        return state.editors;
    },
    isFormModified: (state) => {
        return state.isFormModified;
    },
    state: (state) => {
        return {
            roles: state.roles,
            locations: state.locations,
            editors: state.editors
        };
    },
    deployedVersion: (state) => {
        return state.deployedVersion;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};